import React from 'react';
import { Box, Typography, Button, Link } from 'omaha-design-system';

export const SubscriptionRequiredOverlay: React.FC = () => {
  const handleViewPlans = () => {
    window.location.href = 'https://stokastic.com/pricing';
  };

  return (
    <Box
      sx={{
        width: '100%',
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        pt: 12,
      }}
    >
      {/* Stokastic Logo */}
      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/images/longLogo.png`}
        alt="Stokastic"
        sx={{
          height: 40,
          width: 'auto',
          mb: 4,
        }}
      />

      {/* Headline */}
      <Typography
        sx={{
          fontFamily: '"Gilroy", "Instrument Sans", sans-serif',
          fontWeight: 700,
          fontSize: { xs: 28, sm: 36 },
          color: 'white',
          textAlign: 'center',
          mb: 1.5,
        }}
      >
        NBA Subscription Required
      </Typography>

      {/* Supporting text */}
      <Typography
        sx={{
          fontFamily: '"Instrument Sans", sans-serif',
          fontWeight: 400,
          fontSize: 16,
          color: 'rgba(255, 255, 255, 0.6)',
          textAlign: 'center',
          mb: 4,
          maxWidth: 400,
        }}
      >
        Access to Rotations requires an active NBA subscription. Subscribe to unlock player rotation visualizations and stint analysis.
      </Typography>

      {/* View Plans Button */}
      <Button
        variant="contained"
        onClick={handleViewPlans}
        sx={{
          width: { xs: '100%', sm: 300 },
          maxWidth: 300,
          py: 1.5,
          bgcolor: '#005CCE',
          color: 'white',
          fontFamily: '"Instrument Sans", sans-serif',
          fontWeight: 600,
          fontSize: 16,
          textTransform: 'none',
          borderRadius: '8px',
          mb: 3,
          '&:hover': {
            bgcolor: '#0048A8',
          },
        }}
      >
        View Plans
      </Button>

      {/* Already have a subscription */}
      <Typography
        sx={{
          fontFamily: '"Instrument Sans", sans-serif',
          fontWeight: 400,
          fontSize: 14,
          color: 'rgba(255, 255, 255, 0.6)',
        }}
      >
        Already subscribed?{' '}
        <Link
          href="mailto:support@stokastic.com"
          sx={{
            color: '#4DA3FF',
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline',
            },
          }}
        >
          Contact Support
        </Link>
      </Typography>
    </Box>
  );
};

export default SubscriptionRequiredOverlay;
